var OppStatus;
(function (OppStatus) {
    OppStatus[OppStatus["PAID"] = 7] = "PAID";
    OppStatus[OppStatus["VALIDATION"] = 4] = "VALIDATION";
})(OppStatus || (OppStatus = {}));
var OppSubStatusGroup = (function () {
    function OppSubStatusGroup() {
    }
    OppSubStatusGroup.SUBSTATUSES_CALCULATION_COMPLETED = [15, 16, 17, 18, 19, 20, 21, 22];
    return OppSubStatusGroup;
}());
/* tslint:disable:max-classes-per-file */
var ConfigurationStatus = (function () {
    function ConfigurationStatus($rootScope, $timeout, $q, socket, env, $injector, $filter, settings) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.env = env;
        this.$injector = $injector;
        this.$filter = $filter;
        this.settings = settings;
        this.proProfileLoaded = false;
    }
    // tslint:disable-next-line: typedef
    ConfigurationStatus.prototype.isOppCalculationCompleted = function (status, substatus) {
        var stat = Number(status);
        var subStat = Number(substatus);
        return stat === OppStatus.PAID
            || (stat === OppStatus.VALIDATION && OppSubStatusGroup.SUBSTATUSES_CALCULATION_COMPLETED.includes(subStat));
    };
    /**
     * getProgramStatusFlow  - Get the array of main statuses for a Program by Program Name
     */
    ConfigurationStatus.prototype.getProgramStatusFlow = function (name) {
        var ps = [];
        if (this.settings.program_cfg) {
            angular.forEach(this.settings.program_cfg, function (prg) {
                if (prg.title === name) {
                    ps = prg.process_seq;
                }
            });
        }
        return ps;
    };
    ConfigurationStatus.prototype.loadStatus = function (ev, results) { };
    /**
     * setProgramProfile - Function that will be called when an emit is received from the Config.Program service.
     * The content of the data will be loaded to the config.proProfile variable
     *
     * @param  {type} data: any Result from server either containing an error or the profile data
     */
    ConfigurationStatus.prototype.setProgramProfile = function (data) {
        this.proProfile = data;
        // console.log('program data retrieved');
        if (this.proProfile !== undefined) {
            if (angular.isString(this.proProfile) && this.proProfile.indexOf('ERROR:') > -1) {
                this.proProfileLoaded = false; //it's there but errored
            }
            else {
                this.proProfileLoaded = true; //it's there
            }
        }
        else {
            this.proProfileLoaded = false; //not there
        }
    };
    ConfigurationStatus.prototype.isStageApprover = function (currentUser, mainStatus, subStatus) {
        var found = false;
        var appStage = this.getSubStatusBySubStatusNo2(mainStatus, subStatus);
        appStage.users.some(function (approver) {
            if (approver.email === currentUser) {
                found = true;
                return true; //break
            }
        });
        return found;
    };
    /**
     * hasPreApproval - Function to determine if the program profile is enabled for Pre-Approval stage.  It does
     * this by checking the length of the preapproval_stages array.
     *
     * @return {type}  true if so; false otherwise
     */
    ConfigurationStatus.prototype.hasPreApproval = function () {
        //if (angular.isDefined(this.proProfile) && this.proProfile.preapproval_stages.length > 0) {
        if (this.proProfileLoaded && this.proProfile.preapproval_stages.length > 0) {
            return true;
        }
        return false;
    };
    /**
     * getSubStatusBySubStatusNo - Function to pull the sub-status object from within the status config object by number
     *
     * @param  {type} mainStatus: any       main status object which contains the array of subs within .value
     * @param  {type} sub_status_no: number the sub-status number to search for
     * @return {type}                       the sub-status object containing no, txt and owner
     */
    ConfigurationStatus.prototype.getSubStatusBySubStatusNo = function (mainStatus, sub_status_no) {
        var sub = null;
        mainStatus.subs.some(function (subStatus) {
            if (subStatus.no === sub_status_no) {
                sub = subStatus;
                return true;
            }
        });
        return sub;
    };
    ConfigurationStatus.prototype.getSubStatusBySubStatusNo2 = function (mainStatus, sub_status_no) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        var sub = undefined;
        main.subs.some(function (subStatus) {
            if (subStatus.no === sub_status_no) {
                sub = subStatus;
                return true;
            }
        });
        return sub;
    };
    ConfigurationStatus.prototype.getSubStatusByDesc = function (mainStatus, sub_status_desc) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        var sub = null;
        main.subs.some(function (subStatus) {
            if (subStatus.txt === sub_status_desc) {
                sub = subStatus;
                return true;
            }
        });
        return sub;
    };
    ConfigurationStatus.prototype.getAppStagesForApprover = function (user, peer) {
        var _this = this;
        var stages = [];
        var stage = {};
        //Loop through the statuses
        angular.forEach(this.settings.status_cfg, function (stat) {
            //If status is an approval status
            if ([2, 5].indexOf(stat.no) > -1) {
                //Loop through the sub-statuses
                angular.forEach(stat.subs, function (sub) {
                    //If we're NOT looking for a peer
                    if (peer === null) {
                        if (sub.users && sub.users.length > 0) {
                            //Loop through the users
                            angular.forEach(sub.users, function (bod) {
                                if (bod.email === user) {
                                    stage.main_name = stat.txt;
                                    stage.name = sub.txt;
                                    stage.prez = _this.getAppStageForPrez(stat.no, sub.no, false);
                                    stages.push(stage);
                                    stage = {};
                                }
                            });
                        }
                    }
                    else {
                        if (sub.peer && ((sub.bpso && peer === 'BPSO') || (!sub.bpso && peer === 'Non-BPSO'))) {
                            stage.main_name = stat.txt;
                            stage.name = sub.txt;
                            stage.prez = _this.getAppStageForPrez(stat.no, sub.no, false);
                            stages.push(stage);
                            stage = {};
                        }
                    }
                });
            }
        });
        return stages;
    };
    ConfigurationStatus.prototype.getMainStatusForPrez = function (mainStatus, descOnly) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        if (angular.isUndefined(main)) {
            // console.log('Unable to find Main Status profile for Program Profile pop-up.');
            return;
        }
        if (descOnly) {
            return main.txt;
        }
        var packString = 'Main Status Title : ' + main.txt + '\n' +
            'Status ID : ' + main.no + '\n' +
            'Description : ' + main.desc;
        return packString;
    };
    ConfigurationStatus.prototype.getAppStageForPrez = function (mainStatus, sub_status_no, descOnly) {
        var main = this.getMainStatusByMainStatusNo(mainStatus);
        var sub = null;
        if (angular.isUndefined(main)) {
            // console.log('Unable to find Main Status profile for Program Profile pop-up.');
            return;
        }
        main.subs.some(function (subStatus) {
            if (subStatus.no === sub_status_no) {
                sub = subStatus;
                return true;
            }
        });
        if (sub == null) {
            if (descOnly) {
                return 'Stage not found!!';
            }
            else {
                return 'No such Stage found.  Contact DMT System Administrators.';
            }
        }
        if (descOnly) {
            return sub.txt;
        }
        var packString;
        if ([2, 5].indexOf(mainStatus) > -1) {
            var bpso = sub.bpso ? 'BPSO' : 'Non-BPSO';
            var pmt = void 0;
            var approvers_1 = 'Authorised Approvers :';
            if (!sub.peer) {
                if (sub.manager) {
                    pmt = 'Manager';
                }
                else {
                    pmt = 'Team Leader';
                }
                sub.users.forEach(function (bod) {
                    approvers_1 = approvers_1 + '\n' + bod.name + ' (' + bod.email + ')';
                });
            }
            else {
                pmt = 'Peer/Colleague';
                approvers_1 = 'Authorised Approvers : Anyone within ' + bpso + ' Administration team';
            }
            packString =
                'Stage Title : ' + sub.txt + '\n' +
                    'Approval Stage ID : ' + mainStatus + '-' + sub.no + '\n' +
                    'Cycle Time Owner : ' + sub.owner + '\n' +
                    'Clip Level : ' + this.$filter('currency')(sub.clip, '$', 2) + '\n' +
                    'Responsibility : ' + bpso + ' ' + pmt + '\n' +
                    approvers_1;
        }
        else {
            var sys = angular.isDefined(sub.system) && sub.system ? 'Yes' : 'No';
            packString =
                'Sub-Status Title : ' + sub.txt + '\n' +
                    'Sub-Status ID : ' + mainStatus + '-' + sub.no + '\n' +
                    'Cycle Time Owner : ' + sub.owner + '\n' +
                    'System-Set : ' + sys;
        }
        return packString;
    };
    /**
     * getMainStatusByMainStatusNo - Function to pull the main status object from within the status config object by number
     *
     * @param  {type} status_no: number The main status number to search for
     * @return {type}                   The main status object containing txt, no and array of sub-status objects
     */
    ConfigurationStatus.prototype.getMainStatusByMainStatusNo = function (status_no) {
        var main = null;
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //this.tempData.rows.some((mainStatus: any) => {
            this.settings.status_cfg.some(function (mainStatus) {
                if (mainStatus.no === status_no) {
                    main = mainStatus;
                    return true;
                }
            });
        }
        return main;
    };
    /**
     * getSubStatusesByMainStatusNo - Function to get all sub-status objects for a main status
     *
     * @param  {type} status_no: number The main status number to search for
     * @return {type}                   Array of sub-status objects
     */
    ConfigurationStatus.prototype.getSubStatusesByMainStatusNo = function (status_no) {
        var subs = null;
        var activeSubs = [];
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //this.tempData.rows.some((mainStatus: any) => {
            this.settings.status_cfg.some(function (mainStatus) {
                if (mainStatus.no === status_no) {
                    angular.forEach(mainStatus.subs, function (sub) {
                        // Strip out the inactive ones
                        if (angular.isUndefined(sub.active) || (angular.isDefined(sub.active) && sub.active !== false)) {
                            activeSubs.push(sub);
                        }
                    });
                    return true;
                }
            });
        }
        if (activeSubs.length > 0) {
            return activeSubs;
        }
        return subs;
    };
    /**
     * getAllMainStatuses - Function to build an array of all the Main statuses
     *
     * @return {type}  description
     */
    ConfigurationStatus.prototype.getAllMainStatuses = function () {
        var main = [];
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //angular.forEach(this.tempData.rows, (stat) => {
            angular.forEach(this.settings.status_cfg, function (stat) {
                main.push(stat.txt);
            });
        }
        return main;
    };
    /**
     * getAllSubStatuses - Function to build and array of all the Sub statuses
     *
     * @return {type}  description
     */
    ConfigurationStatus.prototype.getAllSubStatuses = function () {
        var subs = [];
        //if (angular.isDefined(this.tempData.rows)) {
        if (angular.isDefined(this.settings.status_cfg)) {
            //angular.forEach(this.tempData.rows, (stat) => {
            angular.forEach(this.settings.status_cfg, function (stat) {
                angular.forEach(stat.subs, function (sub) {
                    subs.push(sub.txt);
                });
            });
        }
        return subs;
    };
    /**
     * Function to determine in the sub-status in question is a system-set status
     */
    ConfigurationStatus.prototype.isSystemStatus = function (mainStatusNo, subStatusNo) {
        var status = this.getSubStatusBySubStatusNo2(mainStatusNo, subStatusNo);
        if (angular.isDefined(status) && status.system) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     *  getCountryByName - Function to retrieve the full country name based on the full name, ie:
     *                      Germany would return DE
     *  @return {string} Full country name
     */
    ConfigurationStatus.prototype.getCountryByName = function (fullName) {
        var shortName = fullName;
        if (this.settings.country_list) {
            this.settings.country_list.some(function (cty) {
                if (cty.country === fullName) {
                    shortName = cty.cc;
                    return true;
                }
            });
        }
        return shortName;
    };
    /**
     *  getCountryByShort - Function to retrieve the full country name based on the 2 character shortname, ie:
     *                      DE would return Germany
     *  @return {string} Full country name
     */
    ConfigurationStatus.prototype.getCountryByShort = function (shortName) {
        var fullName = shortName;
        if (this.settings.country_list) {
            this.settings.country_list.some(function (cty) {
                if (cty.short === shortName) {
                    fullName = cty.country;
                    return true;
                }
            });
        }
        return fullName;
    };
    /*
        getStatusConfig() {
          this.socket.emit('module', {
              module: {
                  application: 'dmt',
                  function: 'getStatusConfig',
                  script: '/config/config'
              }
          });
        }
    */
    /**
     * getProgramProfile - Function to make call to server looking for Program Profile(s)
     *
     * @param  {type} topic: any Object containing the following fields from the topic: Country,
     * Program, BP Type, Onshore/Offshore and Brands
     */
    ConfigurationStatus.prototype.getProgramProfile = function (topic) {
        var searchCriteria = {
            country: topic.country,
            program: topic.program,
            bpType: topic.bp_type,
            onoff: topic.onshore_offshore,
            brands: topic.brands
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getProgramProfile',
                script: '/config/config',
                sc: searchCriteria,
                token: this.env.user.token
            }
        });
    };
    ConfigurationStatus.prototype.updateStatusConfig = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateStatusConfig',
                script: '/config/config',
                data: data,
                token: this.env.user.token
            }
        });
    };
    ConfigurationStatus.prototype.getLatestTermsOfUse = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getLatestTermsOfUse',
                script: '/config/config',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ConfigurationStatus.prototype.updateUserTermsConfirm = function (vers, profile) {
        this.socket.emit('module', {
            application: 'dmt',
            module: {
                function: 'updateUserTermsConfirm',
                script: '/config/config',
                version: vers,
                user: this.env.user
            }
        });
    };
    ConfigurationStatus.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'env', '$injector', '$filter', 'settings'];
    return ConfigurationStatus;
}());
angular
    .module('application')
    .service('config', ConfigurationStatus);

//# sourceMappingURL=config.js.map
